import styled from 'styled-components';
import { Radio } from '@chegg-ui/radio';
export var ListItem = styled.li.withConfig({
  componentId: "sc-1jaafqq-0"
})(["display:flex;flex-direction:row;justify-content:space-between;padding:0 0 16px 0;div:first-child{padding-left:2px;}svg + div{display:inline-block;width:calc(100% - 20px);}> div,label{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;padding-right:10px;}"]);

// Using inline-block for input type from W3C spec
// https://stackoverflow.com/questions/6867254/browsers-default-css-for-html-elements

export var RadioButtonWrapper = styled(Radio).withConfig({
  componentId: "sc-1jaafqq-1"
})(["input[type='radio']{display:inline-block;}"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/MopListItem/styled.js
// module id = 4573
// module chunks = 11